/**
 * Classifies Markdown link targets in ops checklist step instructions so the
 * renderer can use OsLink for in-app paths and a normal anchor for external URLs.
 */

/** http(s), mailto:, tel: — same rules as the previous inline `safeHref` guard. */
export function safeChecklistInstructionExternalHref(
  href: string | undefined
): string | undefined {
  if (!href) return undefined;
  const t = href.trim();
  if (/^https?:\/\//i.test(t) || t.startsWith("mailto:") || t.startsWith("tel:")) {
    return t;
  }
  return undefined;
}

/**
 * Single-origin path suitable for React Router / OsLink (`/ops/checklists`, …).
 * Rejects protocol-relative URLs (`//host/...`) and whitespace.
 */
export function isChecklistInstructionInternalPathHref(
  href: string | undefined
): boolean {
  if (!href) return false;
  const t = href.trim();
  if (!t.startsWith("/")) return false;
  if (t.startsWith("//")) return false;
  if (/\s/.test(t)) return false;
  return true;
}
